module.exports = __webpack_public_path__ + "static/media/Maf_01Octubre.e8dfa82a.jpg";